import React, { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { Parallax } from "react-parallax";
import { AppContext } from '../main';


const Server = (props) => {
    const {
        handleEditItem
    } = props

    const { appState
    } = useContext(AppContext);
    const {
        banners2 = {
        }
        , editMode = false
    } = appState

    if (!banners2?.data) {
        return null
    }


    return (
        <div className="container">
            <div className="row align-items-center gx-5">
                {/* Image Section */}
                <div className="col-lg-6">
                    <img
                        width="1000"
                        height="600"
                        src={banners2?.image || "./img/misc/server.webp"}
                        className="img-fluid mb-sm-30"
                        alt="Game Server Locations"
                    />
                </div>

                {/* Text Section */}
                <div className="col-lg-6">
                    <div className="subtitle mb-3">{banners2?.title}</div>
                    <h2>
                        <span className="text-gradient">{banners2?.count}</span>{banners2?.subtitle}
                    </h2>
                    <p>
                        {banners2?.description}
                    </p>

                    {/* Server List */}
                    <ul className="de-server">
                        {banners2?.data?.map((server, index) => (
                            <li key={index}>
                                <Link to={server.link}>{server.title}</Link>
                            </li>
                        ))}
                        <li>
                            <Link to="/servers">{banners2?.view}</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Server;
